__turbopack_context__.v({
  "caption": "Stage-module__adgv2q__caption",
  "captionLine": "Stage-module__adgv2q__captionLine",
  "captionTitle": "Stage-module__adgv2q__captionTitle",
  "dot": "Stage-module__adgv2q__dot",
  "dots": "Stage-module__adgv2q__dots",
  "kicker": "Stage-module__adgv2q__kicker",
  "panel": "Stage-module__adgv2q__panel",
  "pin": "Stage-module__adgv2q__pin",
  "stage": "Stage-module__adgv2q__stage",
  "step": "Stage-module__adgv2q__step",
  "view": "Stage-module__adgv2q__view",
});
